export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.config.errorHandler = (err, vm, info) => {
    if (['Network Error'].includes(err?.message)) {

      return ;
    }
    console.error(err)
  }
})
